var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 185.193,
    height: 127.131,
    viewBox: "0 0 185.193 127.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 185.193,
    height: 56.331,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Full",
    "data-name": "Logo Full",
    transform: "translate(-117.866 -57.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(179.09 57.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M21.343,32.226,25.772,39.9H46.713l-4.027,6.974H21.745L11.276,28.738,21.745,10.6H42.686l8.457,14.647H62.418L48.324.838H16.108L0,28.738l16.108,27.9H48.324L62.418,32.226Z",
    transform: "translate(0 -0.838)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M29.673,20.638l-4.429,7.673H46.99l-4.43-7.673Z",
    transform: "translate(-3.9 -3.898)",
    fill: "#f07900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(117.866 128.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650-2",
    "data-name": "Group 650",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M.537,30.258V9.789C.537,3.56,3.65,0,9.659,0S18.78,3.56,18.78,9.789v3.337H13V9.4c0-2.782-1.224-3.838-3.171-3.838S6.654,6.618,6.654,9.4V30.7c0,2.781,1.225,3.781,3.17,3.781S13,33.483,13,30.7v-7.62H9.935V17.52H18.78V30.258c0,6.228-3.116,9.788-9.122,9.788S.537,36.485.537,30.258",
    transform: "translate(-0.084 0)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M27.4,32.775V21.763c0-5.9,3.115-9.233,8.677-9.233s8.677,3.337,8.677,9.233V32.775c0,5.895-3.116,9.232-8.677,9.232S27.4,38.67,27.4,32.775m11.459.556V21.207c0-1.947-.612-3.449-2.782-3.449s-2.78,1.5-2.78,3.449V33.331c0,2,.666,3.448,2.78,3.448s2.782-1.445,2.782-3.448",
    transform: "translate(-4.29 -1.962)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M53.631.659H70.316V6.22H59.748V16.512h8.4v5.561h-8.4V34.03H70.316v5.562H53.631Z",
    transform: "translate(-8.398 -0.103)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M77.914,30.258V28.033H83.7V30.7c0,2.781,1.224,3.781,3.17,3.781s3.227-1,3.227-3.892c0-3.226-1.336-5.228-5.34-8.731-5.118-4.506-6.841-7.732-6.841-12.182C77.914,3.56,81.084,0,87.036,0s8.9,3.56,8.9,9.789V11.4H90.15v-2c0-2.782-1.112-3.838-3.06-3.838s-3.114,1.057-3.114,3.728c0,2.836,1.39,4.839,5.394,8.341,5.117,4.506,6.786,7.677,6.786,12.515,0,6.339-3.226,9.9-9.233,9.9s-9.01-3.56-9.01-9.788",
    transform: "translate(-12.2 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M104.584,30.48V9.567C104.584,3.56,107.7,0,113.594,0s9.01,3.559,9.01,9.566v4.117h-5.786V9.177c0-2.557-1.222-3.614-3.058-3.614S110.7,6.619,110.7,9.177V30.925c0,2.559,1.225,3.559,3.059,3.559s3.058-1,3.058-3.559V25.252H122.6V30.48c0,6.005-3.115,9.565-9.01,9.565s-9.01-3.56-9.01-9.565",
    transform: "translate(-16.376 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M131.338.659H140.4c6.342,0,9.068,2.948,9.068,8.955V12c0,4.006-1.279,6.563-4,7.677v.111c3.059.945,4.06,3.838,4.06,8.233v6.839a11.459,11.459,0,0,0,.667,4.728h-6.23c-.333-1-.556-1.613-.556-4.784V27.69c0-3.614-1.057-4.782-3.838-4.782h-2.113V39.593h-6.118Zm8.342,16.687c2.281,0,3.672-1,3.672-4.117v-3c0-2.782-.945-4.006-3.115-4.006h-2.782V17.346Z",
    transform: "translate(-20.566 -0.103)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M158.391,30.258V9.788c0-6.229,3.281-9.788,9.288-9.788s9.289,3.559,9.289,9.788v20.47c0,6.228-3.281,9.787-9.289,9.787s-9.288-3.559-9.288-9.787m12.459.39V9.4c0-2.782-1.224-3.838-3.171-3.838s-3.17,1.057-3.17,3.838V30.647c0,2.779,1.225,3.836,3.17,3.836s3.171-1.057,3.171-3.836",
    transform: "translate(-24.802 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M184.822.659h5.9L193.5,31.138,196.446.659h6.675l2.948,30.479L208.849.659h5.285l-3.95,38.934h-7.62L199.727,12.84l-2.836,26.753h-8.12Z",
    transform: "translate(-28.94 -0.103)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M0,64.8V55.136H2.572a7.843,7.843,0,0,1,1.879.138,2.129,2.129,0,0,1,1.164.955,3.518,3.518,0,0,1,.458,1.886,3.568,3.568,0,0,1-.4,1.757,2.3,2.3,0,0,1-.989,1,5.127,5.127,0,0,1-2.044.287H1.6V64.8Zm1.6-8.029v2.749h.886a3.859,3.859,0,0,0,1.212-.126,1.077,1.077,0,0,0,.525-.453,1.667,1.667,0,0,0-.006-1.615,1.04,1.04,0,0,0-.523-.443,4.762,4.762,0,0,0-1.314-.112Z",
    transform: "translate(0 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M18.879,64.8H17.145L16.45,62.61H13.278L12.622,64.8h-1.7l3.086-9.664H15.7Zm-2.944-3.823-1.095-3.586-1.073,3.586Z",
    transform: "translate(-1.71 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M26.159,64.8V60.731l-2.9-5.6H25.13l1.862,3.822,1.836-3.822h1.839l-2.913,5.608V64.8Z",
    transform: "translate(-3.642 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M37.039,64.8V55.136h2.393l1.441,6.6,1.429-6.6h2.4V64.8h-1.49V57.186L41.637,64.8H40.1l-1.568-7.614V64.8Z",
    transform: "translate(-5.8 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M52.087,64.8V55.136h5.881V56.77H53.683v2.143h3.982v1.628H53.683v2.624h4.43V64.8Z",
    transform: "translate(-8.156 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M64.938,64.8V55.136h1.556l3.243,6.453V55.136h1.49V64.8H69.618l-3.191-6.3v6.3Z",
    transform: "translate(-10.168 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M80.151,64.8V56.77H77.8V55.136h6.3V56.77H81.747V64.8Z",
    transform: "translate(-12.182 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M98.3,64.8V55.136h2.572a7.843,7.843,0,0,1,1.879.138,2.129,2.129,0,0,1,1.164.955,3.518,3.518,0,0,1,.458,1.886,3.568,3.568,0,0,1-.4,1.757,2.3,2.3,0,0,1-.989,1,5.127,5.127,0,0,1-2.044.287H99.9V64.8Zm1.6-8.029v2.749h.886A3.859,3.859,0,0,0,102,59.394a1.077,1.077,0,0,0,.525-.453,1.667,1.667,0,0,0-.006-1.615,1.04,1.04,0,0,0-.523-.443,4.762,4.762,0,0,0-1.314-.112Z",
    transform: "translate(-15.393 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M111.147,64.8V55.135h3.369a4.687,4.687,0,0,1,1.845.261,2.044,2.044,0,0,1,.91.9,3.138,3.138,0,0,1,.356,1.539,2.868,2.868,0,0,1-.544,1.826,2.417,2.417,0,0,1-1.546.871,3.963,3.963,0,0,1,.85.807,11.272,11.272,0,0,1,.917,1.572l.963,1.885h-1.909L115.2,62.7a13.628,13.628,0,0,0-.849-1.427,1.25,1.25,0,0,0-.474-.4,2.171,2.171,0,0,0-.8-.109h-.331V64.8Zm1.6-5.577h1.187a5.977,5.977,0,0,0,1.385-.1.881.881,0,0,0,.481-.385,1.422,1.422,0,0,0,.185-.772,1.326,1.326,0,0,0-.185-.741.934.934,0,0,0-.5-.385,6.286,6.286,0,0,0-1.3-.073h-1.252Z",
    transform: "translate(-17.404 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M124.313,60a6.862,6.862,0,0,1,.511-2.845,3.852,3.852,0,0,1,1.334-1.665,3.537,3.537,0,0,1,2-.547,3.429,3.429,0,0,1,2.772,1.3,5.673,5.673,0,0,1,1.071,3.7,5.76,5.76,0,0,1-1.134,3.79,3.659,3.659,0,0,1-5.418.013A5.685,5.685,0,0,1,124.313,60m1.648-.067a4.106,4.106,0,0,0,.634,2.5,1.907,1.907,0,0,0,1.57.833,1.884,1.884,0,0,0,1.565-.827,4.242,4.242,0,0,0,.621-2.542,4.138,4.138,0,0,0-.6-2.485,1.885,1.885,0,0,0-1.581-.8,1.907,1.907,0,0,0-1.59.81,4.16,4.16,0,0,0-.615,2.512",
    transform: "translate(-19.466 -8.603)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M140.674,64.8V56.77h-2.353V55.136h6.3V56.77H142.27V64.8Z",
    transform: "translate(-21.659 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M151.1,64.8V55.136h5.881V56.77H152.7v2.143h3.982v1.628H152.7v2.624h4.43V64.8Z",
    transform: "translate(-23.66 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M168.954,61.216l1.549.6a4.344,4.344,0,0,1-1.206,2.369,3.018,3.018,0,0,1-2.077.748,3.073,3.073,0,0,1-2.511-1.193,5.768,5.768,0,0,1-1.108-3.718,6.056,6.056,0,0,1,1.116-3.87,3.164,3.164,0,0,1,2.606-1.212,3.008,3.008,0,0,1,2.231.909,3.938,3.938,0,0,1,.936,1.918l-1.582.462a2.137,2.137,0,0,0-.6-1.2,1.518,1.518,0,0,0-1.066-.418,1.7,1.7,0,0,0-1.433.764,4.4,4.4,0,0,0-.556,2.525,4.679,4.679,0,0,0,.541,2.6,1.645,1.645,0,0,0,1.4.771,1.453,1.453,0,0,0,1.095-.491,3.113,3.113,0,0,0,.665-1.559",
    transform: "translate(-25.617 -8.603)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M179.167,64.8V56.77h-2.353V55.136h6.3V56.77h-2.347V64.8Z",
    transform: "translate(-27.686 -8.633)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 1.596,
    height: 9.664,
    transform: "translate(159.854 46.503)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M196.937,60a6.862,6.862,0,0,1,.511-2.845,3.852,3.852,0,0,1,1.334-1.665,3.536,3.536,0,0,1,2-.547,3.429,3.429,0,0,1,2.772,1.3,5.673,5.673,0,0,1,1.071,3.7,5.76,5.76,0,0,1-1.134,3.79,3.659,3.659,0,0,1-5.418.013A5.685,5.685,0,0,1,196.937,60m1.648-.067a4.106,4.106,0,0,0,.634,2.5,1.907,1.907,0,0,0,1.57.833,1.884,1.884,0,0,0,1.565-.827,4.242,4.242,0,0,0,.621-2.542,4.138,4.138,0,0,0-.6-2.485,1.885,1.885,0,0,0-1.581-.8,1.907,1.907,0,0,0-1.59.81,4.16,4.16,0,0,0-.615,2.512",
    transform: "translate(-30.837 -8.603)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M211.641,64.8V55.136H213.2l3.243,6.453V55.136h1.49V64.8h-1.608l-3.191-6.3v6.3Z",
    transform: "translate(-33.14 -8.633)",
    fill: "#525252"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.06780511d8eca89079dc4a5df600d2e2.svg";
export { ForwardRef as ReactComponent };